<template lang="pug">
.u-margin-top-8x
  h3.p-title.p-title--icon {{$t('shared.risk_objects.generic.digital_bag')}}
    Icon(icon="digital_bag" classes="p-title__icon")
  Ownership(risk="digital_bag" risk_object="omnium")
</template>

<script>
import Icon from '../shared/Icon'
import Ownership from './Ownership'

export default {
  components: {
    Icon,
    Ownership
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/DigitalBag.vue